import './LoginScene.css'

/**
 * Giriş ekranının sol sütunundaki sahne (16 Eki 2026).
 *
 * Adisyonun ruhu: garson masanın başında telefonla siparişi alıyor, sipariş
 * tezgahtaki Adissoo paneline uçuyor. SVG çizim; fotoğraflı bir sürüm de
 * denendi, kullanıcı çizimi seçti.
 *
 * Yalnız geniş ekranda; telefonda sütun zaten yalnız logoya iniyor.
 */

/** Paneldeki masalar: 0 boş, 1 dolu, 2 siparişi yeni gelen (Masa 4). */
const TILES = [1, 0, 1, 2, 1, 0]

export function LoginScene() {
  return (
    <svg className="lscene" viewBox="0 0 640 520" role="img" aria-label="Garson masada telefonla sipariş alıyor, sipariş tezgahtaki Adissoo paneline düşüyor">
      <defs>
        <linearGradient id="ls-wall" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#1c1814" />
          <stop offset="1" stopColor="#141110" />
        </linearGradient>
        <linearGradient id="ls-floor" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2a211a" />
          <stop offset="1" stopColor="#1a1410" />
        </linearGradient>
        <radialGradient id="ls-glow">
          <stop offset="0" stopColor="#ffb45e" stopOpacity="0.55" />
          <stop offset="1" stopColor="#ffb45e" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="ls-cone" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffc77a" stopOpacity="0.22" />
          <stop offset="1" stopColor="#ffc77a" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="ls-orange" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ff7a3d" />
          <stop offset="1" stopColor="#e2470f" />
        </linearGradient>
        <radialGradient id="ls-phone-glow">
          <stop offset="0" stopColor="#ffd2b8" stopOpacity="0.7" />
          <stop offset="1" stopColor="#ffd2b8" stopOpacity="0" />
        </radialGradient>
        <clipPath id="ls-room">
          <rect x="0" y="0" width="640" height="520" rx="28" />
        </clipPath>
      </defs>

      <g clipPath="url(#ls-room)">
        {/* Oda */}
        <rect width="640" height="520" fill="url(#ls-wall)" />
        {/* Duvarda ince çıtalar */}
        {[80, 160, 240, 320, 400, 480, 560].map((x) => (
          <line key={x} x1={x} y1="0" x2={x} y2="430" stroke="#ffffff" strokeOpacity="0.025" strokeWidth="2" />
        ))}
        <rect y="430" width="640" height="90" fill="url(#ls-floor)" />
        {[0, 1, 2, 3].map((i) => (
          <line key={i} x1="0" y1={448 + i * 20} x2="640" y2={448 + i * 20} stroke="#000" strokeOpacity="0.18" />
        ))}

        {/* Duvarda menü tahtası */}
        <g transform="translate(540 136) scale(0.62)">
          <rect width="128" height="92" rx="8" fill="#22302a" stroke="#8a6a46" strokeWidth="5" />
          <text x="64" y="26" textAnchor="middle" className="lscene__chalk lscene__chalk--title">MENÜ</text>
          {[42, 56, 70].map((y, i) => (
            <g key={y}>
              <line x1="16" y1={y} x2={74 - i * 8} y2={y} stroke="#e9efe9" strokeOpacity="0.55" strokeWidth="3" strokeLinecap="round" />
              <line x1="96" y1={y} x2="112" y2={y} stroke="#ffb27a" strokeOpacity="0.8" strokeWidth="3" strokeLinecap="round" />
            </g>
          ))}
        </g>

        {/* Bitki */}
        <g transform="translate(596 352)">
          <path d="M-14 78 h28 l-4 -36 h-20 z" fill="#5a3b28" />
          <path d="M0 44 C -30 20 -26 -10 -6 -30 C -2 -6 -2 20 0 44 Z" fill="#2f6b4a" />
          <path d="M0 44 C 26 18 30 -6 14 -26 C 8 -2 4 22 0 44 Z" fill="#3c8a5d" />
          <path d="M0 44 C -8 10 -2 -20 4 -44 C 12 -16 8 18 0 44 Z" fill="#46a06c" />
        </g>

        {/* Sarkıt lambalar ve ışık konileri */}
        {[150, 330, 500].map((x, i) => (
          <g key={x} className={`lscene__lamp lscene__lamp--${i}`}>
            <polygon points={`${x - 20},104 ${x + 20},104 ${x + 110},440 ${x - 110},440`} fill="url(#ls-cone)" />
            <circle cx={x} cy="104" r="70" fill="url(#ls-glow)" />
            <line x1={x} y1="0" x2={x} y2="78" stroke="#5c534b" strokeWidth="2" />
            <path d={`M${x - 8} 78 h16 l16 26 h-48 z`} fill="#e8a33d" />
            <ellipse cx={x} cy="104" rx="24" ry="4" fill="#fff4d6" />
          </g>
        ))}

        {/* Tezgah ve panel ekranı */}
        <g>
          <rect x="22" y="346" width="240" height="12" rx="4" fill="#8a5a36" />
          <rect x="30" y="358" width="224" height="112" fill="#3a2a1f" />
          {[0, 1, 2].map((i) => (
            <rect key={i} x={40 + i * 72} y="370" width="60" height="88" rx="4" fill="#ffffff" fillOpacity="0.035" />
          ))}

          {/* Ekran ayağı */}
          <rect x="132" y="316" width="16" height="30" fill="#2b2b2b" />
          <rect x="108" y="340" width="64" height="7" rx="3" fill="#333" />

          {/* Ekran */}
          <rect x="44" y="176" width="192" height="146" rx="12" fill="#0c0c0c" />
          <rect x="51" y="183" width="178" height="132" rx="7" fill="#f7f5f2" />
          {/* Üst çubuk: logo ve "Masalar" */}
          <rect x="51" y="183" width="178" height="22" rx="7" fill="#ffffff" />
          <rect x="51" y="198" width="178" height="7" fill="#ffffff" />
          <circle cx="64" cy="194" r="5" fill="url(#ls-orange)" />
          <text x="74" y="198" className="lscene__ui lscene__ui--bold">Masalar</text>
          <rect x="190" y="189" width="30" height="10" rx="5" fill="#ffe7da" />
          <text x="205" y="197" textAnchor="middle" className="lscene__ui lscene__ui--accent">3 açık</text>
          {/* Masa kutuları */}
          {TILES.map((state, i) => {
            const x = 60 + (i % 3) * 56
            const y = 214 + Math.floor(i / 3) * 48
            return (
              <g key={i} className={state === 2 ? 'lscene__tile-new' : undefined}>
                <rect
                  x={x}
                  y={y}
                  width="48"
                  height="40"
                  rx="7"
                  fill={state === 0 ? '#ffffff' : state === 1 ? '#fff1e8' : 'url(#ls-orange)'}
                  stroke={state === 0 ? '#e6e1da' : state === 1 ? '#ffd2b8' : 'none'}
                />
                <text x={x + 8} y={y + 15} className={`lscene__ui lscene__ui--bold ${state === 2 ? 'lscene__ui--white' : ''}`}>
                  Masa {i + 1}
                </text>
                {state !== 0 && (
                  <rect x={x + 8} y={y + 22} width={state === 2 ? 30 : 22} height="5" rx="2.5" fill={state === 2 ? '#ffffff' : '#ff8a52'} fillOpacity={state === 2 ? 0.85 : 0.6} />
                )}
                {state === 2 && <circle cx={x + 40} cy={y + 9} r="4" fill="#ffffff" className="lscene__ping" />}
              </g>
            )
          })}

          {/* Tezgahta çay bardağı */}
          <g transform="translate(240 324)">
            <path d="M0 0 h14 l-2 22 h-10 z" fill="#c2410c" fillOpacity="0.85" stroke="#fff" strokeOpacity="0.5" />
            <path d="M5 -4 q-4 -8 2 -14 M10 -4 q-4 -8 2 -14" stroke="#fff" strokeOpacity="0.35" strokeWidth="1.6" fill="none" className="lscene__steam" />
          </g>
        </g>

        {/* Masa, sandalye ve müşteri */}
        <g>
          {/* Arka sandalye */}
          <rect x="532" y="300" width="10" height="150" rx="3" fill="#6b4630" />
          <rect x="514" y="300" width="52" height="10" rx="4" fill="#7a5036" />

          {/* Müşteri: garsona (sola) dönük, omza dökülen saç, topuz */}
          <g>
            {/* Arkadaki uzun saç: omuzlara dökülüyor */}
            <path d="M502 298 C 498 318 497 332 490 344 L 554 344 C 547 330 545 316 542 298 Z" fill="#4a2a1b" />
            {/* Gövde: kazak */}
            <path d="M484 400 C 484 350 494 330 522 330 C 550 330 562 350 562 400 Z" fill="#2f7f86" />
            <path d="M511 332 q11 7 22 0" stroke="#256970" strokeWidth="3" fill="none" strokeLinecap="round" />
            {/* Boyun */}
            <rect x="514.5" y="314" width="14" height="19" rx="5" fill="#d99a6c" />
            <path d="M514.5 319 q7 4 14 0 v-5 h-14 z" fill="#c4865a" />
            {/* Yüz: oval, garsona (sola) hafif dönük */}
            <ellipse cx="521" cy="302" rx="15.5" ry="18" fill="#e5a97b" />
            {/* Saç: yandan ayrılmış, alnı yarım örten perçem */}
            <path
              d="M504 304 C 501 285 510 272 524 272 C 538 272 545 284 542 302 C 541 306 540 309 538 311 C 538 300 536 292 531 287 C 526 291 516 293 508 292 C 506 296 505 300 504 304 Z"
              fill="#4a2a1b"
            />
            <path d="M510 281 C 516 276 527 274 536 278" stroke="#6e4430" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.8" />
            {/* Topuz */}
            <circle cx="537" cy="268" r="9.5" fill="#4a2a1b" />
            <path d="M531 266 q6 -5 12 1" stroke="#6e4430" strokeWidth="1.6" fill="none" strokeLinecap="round" />
            {/* Kaşlar ve gözler */}
            <path d="M508 296 q3.5 -2.5 7 0" stroke="#4a2a1b" strokeWidth="1.8" fill="none" strokeLinecap="round" />
            <path d="M520 296 q3.5 -2.5 7 0" stroke="#4a2a1b" strokeWidth="1.8" fill="none" strokeLinecap="round" />
            <ellipse cx="511.5" cy="301" rx="1.8" ry="2.3" fill="#2a1a12" />
            <ellipse cx="523.5" cy="301" rx="1.8" ry="2.3" fill="#2a1a12" />
            {/* Burun, gülümseme, yanaklar, küpe */}
            <path d="M516 303 q-1.5 4 1.5 5" stroke="#c4865a" strokeWidth="1.4" fill="none" strokeLinecap="round" />
            <path d="M512 312 q5 4 10 0" stroke="#9a4b33" strokeWidth="1.8" fill="none" strokeLinecap="round" />
            <circle cx="508" cy="308" r="3.2" fill="#e2785a" opacity="0.3" />
            <circle cx="528" cy="308" r="3.2" fill="#e2785a" opacity="0.3" />
            <circle cx="537" cy="314" r="2.2" fill="#f2c14e" />
            {/* Menüyü gösteren el */}
            <path d="M494 362 C 478 366 466 374 456 382" stroke="#2f7f86" strokeWidth="13" strokeLinecap="round" fill="none" />
            <circle cx="454" cy="383" r="6.5" fill="#e5a97b" />
          </g>

          {/* Masa */}
          <ellipse cx="500" cy="394" rx="86" ry="15" fill="#a56a3f" />
          <rect x="414" y="394" width="172" height="8" fill="#7f4f2e" />
          <ellipse cx="500" cy="402" rx="86" ry="8" fill="#7f4f2e" />
          <rect x="494" y="402" width="12" height="66" fill="#5b3a24" />
          <ellipse cx="500" cy="470" rx="36" ry="6" fill="#3e281a" />
          {/* Masada tabak, bardak ve masa numarası */}
          <ellipse cx="520" cy="390" rx="22" ry="5" fill="#f4efe8" />
          <ellipse cx="520" cy="388" rx="12" ry="3" fill="#e0b25c" />
          <path d="M556 372 h10 l-1.5 18 h-7 z" fill="#ffffff" fillOpacity="0.5" />
          {/* Servisin bıraktığı içecekler: tepsidekiler kaybolunca beliriyor */}
          <g className="lscene__table-drinks">
            <path d="M426 372 h10 l-1.2 20 h-7.6 z" fill="#f7d774" fillOpacity="0.9" stroke="#ffffff" strokeOpacity="0.6" strokeWidth="1" />
            <path d="M434 369 l2.5 -8" stroke="#ff7a3d" strokeWidth="1.6" strokeLinecap="round" />
            <path d="M442 378 c-1.6 3 -1.6 5 0 6.5 c-1.6 1.6 -1.6 5 0 6.5 h7.5 c1.6 -1.5 1.6 -4.9 0 -6.5 c1.6 -1.5 1.6 -3.5 0 -6.5 z" fill="#b8410f" fillOpacity="0.9" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="1" />
          </g>
          <g transform="translate(470 370)">
            <rect width="20" height="16" rx="3" fill="#ffffff" />
            <text x="10" y="12" textAnchor="middle" className="lscene__ui lscene__ui--bold lscene__ui--accent">4</text>
          </g>
        </g>

        {/* Dış grup bardan masaya yürütüyor, içteki adım adım sekiyor (ayrı
            gruplar: iki animasyonun transform'u birbirini ezmesin). Garsonun
            arkasından geçiyor, tepsi başının üstünde. */}
        <g className="lscene__runner-path">
        <g className="lscene__runner">
          {/* Bacaklar: adım atarken */}
          <g className="lscene__leg lscene__leg--a">
            <path d="M291 380 L 289 462" stroke="#24242a" strokeWidth="15" strokeLinecap="round" />
            <ellipse cx="292" cy="468" rx="12" ry="4.5" fill="#0d0d0f" />
          </g>
          <g className="lscene__leg lscene__leg--b">
            <path d="M299 380 L 301 462" stroke="#1d1d22" strokeWidth="15" strokeLinecap="round" />
            <ellipse cx="304" cy="468" rx="12" ry="4.5" fill="#0d0d0f" />
          </g>
          {/* Arkadaki kol: yürürken geride */}
          <path d="M280 312 C 270 332 266 350 268 366" stroke="#26303b" strokeWidth="12" strokeLinecap="round" fill="none" />
          <circle cx="268" cy="370" r="6" fill="#c58a62" />
          {/* Gövde: koyu gömlek, turuncu önlük */}
          <path d="M274 388 C 272 334 280 300 299 296 C 318 300 326 334 324 388 Z" fill="#26303b" />
          <path d="M290 298 l9 10 l9 -10" stroke="#3b4756" strokeWidth="3" fill="none" strokeLinejoin="round" />
          <path d="M278 352 h42 l4 46 c-14 6 -36 6 -50 0 z" fill="url(#ls-orange)" />
          <rect x="274" y="348" width="50" height="6" rx="3" fill="#c2410c" />
          {/* Boyun ve baş: masaya (sağa) dönük */}
          <rect x="293" y="278" width="13" height="20" rx="5" fill="#c58a62" />
          <path d="M293 284 q6.5 4 13 0 v-6 h-13 z" fill="#a8704b" />
          <ellipse cx="301" cy="263" rx="15" ry="18" fill="#c58a62" />
          {/* Küt saç, yandan ayrılmış */}
          <path
            d="M284 272 C 280 252 287 238 302 237 C 317 237 323 250 320 266 C 319 272 317 276 315 279 C 315 268 313 259 308 253 C 301 257 292 257 288 255 C 287 262 287 269 289 278 Z"
            fill="#1a1210"
          />
          <path d="M290 244 C 296 240 306 239 313 243" stroke="#3a2a22" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.8" />
          {/* Kaşlar, gözler, burun, gülümseme, yanak */}
          <path d="M300 256 q3 -2 6 0" stroke="#1a1210" strokeWidth="1.7" fill="none" strokeLinecap="round" />
          <path d="M310 256 q3 -2 6 0" stroke="#1a1210" strokeWidth="1.7" fill="none" strokeLinecap="round" />
          <ellipse cx="303" cy="261" rx="1.7" ry="2.2" fill="#1f130d" />
          <ellipse cx="313" cy="261" rx="1.7" ry="2.2" fill="#1f130d" />
          <path d="M309 263 q2 4 -1 5" stroke="#a8704b" strokeWidth="1.3" fill="none" strokeLinecap="round" />
          <path d="M304 272 q4.5 3.5 9 0" stroke="#7a3f25" strokeWidth="1.8" fill="none" strokeLinecap="round" />
          <circle cx="300" cy="268" r="3" fill="#e2785a" opacity="0.28" />
          {/* Öndeki kol: tepsiyi omuz hizasında taşıyor */}
          <path d="M318 308 C 336 302 344 272 341 240" stroke="#26303b" strokeWidth="12" strokeLinecap="round" fill="none" />
          <circle cx="341" cy="235" r="6" fill="#c58a62" />
          {/* Tepsi ve içecekler: limonata ve ince belli bardakta çay */}
          <g transform="translate(0 -48)">
          <ellipse cx="342" cy="278" rx="26" ry="4.5" fill="#d9d4cc" />
          <ellipse cx="342" cy="277" rx="26" ry="3.5" fill="#efebe5" />
          <g className="lscene__tray-drinks">
            <path d="M326 252 h12 l-1.5 24 h-9 z" fill="#f7d774" fillOpacity="0.9" stroke="#ffffff" strokeOpacity="0.6" strokeWidth="1" />
            <rect x="325" y="250" width="14" height="3" rx="1.5" fill="#ffffff" fillOpacity="0.5" />
            <circle cx="337" cy="252" r="4.5" fill="#f2c14e" stroke="#fff3c4" strokeWidth="1" />
            <path d="M335 248 l3 -10" stroke="#ff7a3d" strokeWidth="1.8" strokeLinecap="round" />
            <path d="M348 260 c-2 4 -2 6 0 8 c-2 2 -2 6 0 8 h9 c2 -2 2 -6 0 -8 c2 -2 2 -4 0 -8 z" fill="#b8410f" fillOpacity="0.9" stroke="#ffffff" strokeOpacity="0.55" strokeWidth="1" />
            <path d="M350 255 q-3 -6 1 -10 M355 255 q-3 -6 1 -10" stroke="#fff" strokeOpacity="0.35" strokeWidth="1.4" fill="none" className="lscene__steam" />
          </g>
          </g>
        </g>
        </g>

        {/* Garson: masaya doğru hafif eğilmiş, elinde telefon */}
        <g className="lscene__waiter">
          {/* Bacaklar */}
          <path d="M366 372 L 360 466" stroke="#1d1d22" strokeWidth="17" strokeLinecap="round" />
          <path d="M390 372 L 398 466" stroke="#24242a" strokeWidth="17" strokeLinecap="round" />
          <ellipse cx="356" cy="470" rx="14" ry="5" fill="#0d0d0f" />
          <ellipse cx="404" cy="470" rx="14" ry="5" fill="#0d0d0f" />

          <g transform="rotate(9 378 372)">
            {/* Gövde: beyaz gömlek, siyah yelek */}
            <path d="M350 384 C 348 330 354 296 378 292 C 402 296 410 330 408 384 Z" fill="#f2efe9" />
            <path d="M352 384 C 350 336 356 306 366 298 L 378 336 L 390 298 C 402 306 408 336 406 384 Z" fill="#1f1f24" />
            {/* Turuncu önlük */}
            <path d="M354 352 h48 l4 52 c-16 6 -40 6 -56 0 z" fill="url(#ls-orange)" />
            <rect x="350" y="348" width="56" height="6" rx="3" fill="#c2410c" />
            {/* Papyon */}
            <path d="M370 300 l8 5 l8 -5 v10 l-8 -5 l-8 5 z" fill="#e2470f" />
            {/* Boyun: çenenin altı gölgeli */}
            <rect x="372" y="276" width="15" height="22" rx="6" fill="#c98a5e" />
            <path d="M372 284 q8 6 15 0 v-6 h-15 z" fill="#b5764d" />
            {/* Baş: dörtte üç profil, telefona (sağa) dönük; burun ve çene çıkıntılı */}
            <path
              d="M366 254 C 365 240 375 233 386 234 C 397 235 402 245 401 255 C 401 260 403 264 406 268 C 407 270 405 272 402 272 C 402 278 399 284 392 286 C 383 288 372 285 368 277 C 365 271 365 263 366 254 Z"
              fill="#d99a6c"
            />
            {/* Kulak */}
            <ellipse cx="371" cy="265" rx="4.5" ry="6.5" fill="#c98a5e" />
            <path d="M372 262 q-2 3 0 6" stroke="#a96a44" strokeWidth="1.4" fill="none" strokeLinecap="round" />
            {/* Saç: yana taranmış kısa saç, önde kabarık, kulağın önünde favori */}
            <path
              d="M363 262 C 359 246 363 232 377 227 C 389 223 400 227 405 236 C 408 242 406 248 401 250 C 396 245 389 244 384 247 C 380 250 377 252 376 257 C 374 259 371 258 369 257 C 366 258 365 261 364 264 Z"
              fill="#24160f"
            />
            <path d="M376 256 q1 5 1.5 9" stroke="#24160f" strokeWidth="2.6" fill="none" strokeLinecap="round" />
            <path d="M372 233 C 381 229 393 229 400 236" stroke="#5a3a28" strokeWidth="2.2" fill="none" strokeLinecap="round" opacity="0.8" />
            <path d="M366 246 C 368 240 372 236 377 234" stroke="#5a3a28" strokeWidth="1.6" fill="none" strokeLinecap="round" opacity="0.6" />
            {/* Kaş, telefona bakan göz, burun gölgesi, gülümseme, yanak */}
            <path d="M388 253 q5 -2.5 10 0" stroke="#24160f" strokeWidth="2.2" fill="none" strokeLinecap="round" />
            <path d="M389 261 q4.5 2.5 8 0" stroke="#2a1a12" strokeWidth="2" fill="none" strokeLinecap="round" />
            <path d="M401 266 q-2 3 1 5" stroke="#b5764d" strokeWidth="1.4" fill="none" strokeLinecap="round" />
            <path d="M390 277 q5 3 9 -1" stroke="#7a3f25" strokeWidth="2" fill="none" strokeLinecap="round" />
            <circle cx="388" cy="270" r="4" fill="#e2785a" opacity="0.3" />
            {/* Arkadaki kol: aşağıda */}
            <path d="M356 312 C 346 336 344 356 348 372" stroke="#f2efe9" strokeWidth="13" strokeLinecap="round" fill="none" />
            <circle cx="348" cy="376" r="6.5" fill="#d99a6c" />
            {/* Öndeki kol: telefonu tutuyor */}
            <path d="M400 310 C 412 330 414 338 426 336" stroke="#f2efe9" strokeWidth="13" strokeLinecap="round" fill="none" />
            <circle cx="430" cy="334" r="6.5" fill="#d99a6c" />
          </g>

          {/* Telefon ve ekran ışığı */}
          <circle cx="438" cy="312" r="34" fill="url(#ls-phone-glow)" className="lscene__phone-glow" />
          <g transform="rotate(-14 438 316)">
            <rect x="428" y="296" width="20" height="36" rx="4" fill="#111" />
            <rect x="430" y="299" width="16" height="30" rx="2.5" fill="#fff6ef" />
            <rect x="432" y="302" width="12" height="3" rx="1.5" fill="#ff7a3d" />
            <rect x="432" y="308" width="10" height="2" rx="1" fill="#c9bfb5" />
            <rect x="432" y="312" width="8" height="2" rx="1" fill="#c9bfb5" />
            <rect x="432" y="322" width="12" height="4" rx="2" fill="#ff7a3d" />
          </g>
        </g>

        {/* Servis: bardan içecek götüren ikinci çalışan, masaya doğru yürüyor */}
        {/* Telefondan panele uçan sipariş */}
        <path
          d="M440 296 C 410 170 300 140 236 214"
          stroke="#ff8a52"
          strokeOpacity="0.35"
          strokeWidth="2"
          strokeDasharray="4 7"
          fill="none"
          className="lscene__trail"
        />
        <g className="lscene__order">
          <rect x="-46" y="-15" width="92" height="30" rx="10" fill="#ffffff" />
          <circle cx="-31" cy="0" r="8" fill="url(#ls-orange)" />
          <path d="M-35 0 l3 3 l5 -6" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          <text x="-18" y="-2" className="lscene__ui lscene__ui--bold lscene__ui--big">Masa 4</text>
          <text x="-18" y="9" className="lscene__ui lscene__ui--muted">3 ürün, sipariş</text>
        </g>
      </g>
    </svg>
  )
}
